module.exports = __webpack_public_path__ + "img/switch.76cdfd50.svg";